import { ICustomer } from "@/types/ICustomer"
import { ITableColumn } from "@/types/ui"


export const customerColumns: ITableColumn<ICustomer>[] = [
  {
    title: "Код контрагента",
    key: "id",
    dataIndex: ["id"],
    align: "center",
    sorter: true,
    isVisible: false,
    order: 1
  },
  {
    title: "Клиент",
    key: "customerClientName",
    dataIndex: ["customerClientName"],
    align: "center",
    sorter: true,
    isVisible: true,
    order: 2
  },
  {
    title: "Контрагент",
    key: "name",
    dataIndex: ["name"],
    align: "center",
    //render: (_, customer: ICustomer) => <NavLink to={paths.customerById(customer.id)}>{customer.name}</NavLink>,
    sorter: true,
    defaultSortOrder: "ascend",
    isVisible: true,
    order: 3
  },
  {
    title: "Баланс",
    key: "balance",
    dataIndex: ["balance"],
    align: "center",
    sorter: true,
    isVisible: false,
    order: 4
  },
  {
    title: "Сумма заказов в работе",
    key: "sumOrder",
    dataIndex: ["sumOrder"],
    align: "center",
    sorter: true,
    isVisible: false,
    order: 5
  },
  {
    title: "Сумма доступная для заказа",
    key: "availableSum",
    dataIndex: ["availableSum"],
    align: "center",
    sorter: true,
    isVisible: false,
    order: 6
  },
  {
    title: "Дневной лимит",
    key: "dayLimit",
    dataIndex: ["dayLimit"],
    align: "center",
    sorter: true,
    isVisible: false,
    order: 7
  },
  {
    title: "Телефон",
    key: "phone",
    dataIndex: ["phone"],
    align: "center",
    render: (_, customer: ICustomer) => customer.phone ? `+7 ${customer.phone}` : "-",
    sorter: true,
    isVisible: true,
    order: 8
  },
  {
    title: "ИНН",
    key: "inn",
    dataIndex: ["inn"],
    align: "center",
    sorter: true,
    isVisible: true,
    order: 9
  },
  {
    title: "ОГРН",
    key: "ogrn",
    dataIndex: ["ogrn"],
    align: "center",
    sorter: true,
    isVisible: true,
    order: 10
  }
]